import { render, staticRenderFns } from "./ColumnUpdate.vue?vue&type=template&id=6404ce52"
import script from "./ColumnUpdate.vue?vue&type=script&lang=js"
export * from "./ColumnUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports